<template>
  <div class="ts-relative ts-w-full">
    <input
      v-model.trim="model.text"
      ref="search"
      type="text"
      class="
        ts-w-full
        ts-border
        ts-float-right
        ts-px-2
        ts-py-1
        ts-rounded
        ts-outline-none
        ts-pr-6
      "
      :placeholder="$t('deliveryOrder.searchInvoiceList')"
    />
    <span class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2" style="margin-top: 7px"
      ><i class="fa fa-search"></i
    ></span>
  </div>
</template>
<script>
export default {
  props: ['value'],
  data() {
    return {
      model: {
        text: '',
      },
    }
  },
  created() {
    this.model = this.value
  },
}
</script>